export const productShortName = 'Industrial Chemistry & Chemical Processes — Professional Edition™';
export const productBrand = 'Industrial Chemistry & Chemical Processes';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/uHzhATY2SA6hVhohhntDa4/MOCKUP_(2).png';

export const checkoutUrl = 'https://industrial-chemistry-chemical-processes.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about chemical reactions and industrial processes',
  'No more uncertain technical explanations to colleagues',
  'No more struggling with equipment operation and unit operations',
  'No more gaps in understanding process control and optimization',
  "No more limited career advancement because technical knowledge isn't documented",
];
